import { useLang } from "@/context/LanguageContext";
import { SectionHead, MaskWords } from "@/components/site/primitives";
import { Reveal } from "@/components/site/Reveal";

export default function Principles() {
  const { t } = useLang();
  const p = t.principles;

  return (
    <section id="principles" className="bg-paper text-ink px-6 md:px-12 lg:px-20 py-28 md:py-40">
      <SectionHead label={p.label} index="" />
      <div className="mt-10 md:mt-14 mb-16 md:mb-24">
        <MaskWords
          Tag="h2"
          text={p.title}
          className="display uppercase text-[12vw] lg:text-[8.5vw] leading-[0.85] break-words"
        />
      </div>

      <div className="border-t border-ink/15">
        {p.items.map((it, i) => (
          <Reveal key={i}>
            <div className="grid grid-cols-12 gap-6 md:gap-10 py-9 md:py-12 border-b border-ink/15 group">
              <h3 className="col-span-12 lg:col-span-5 font-display text-3xl md:text-4xl leading-[1.02] transition-transform duration-500 group-hover:translate-x-2">
                {it.t}
              </h3>
              <p className="col-span-12 lg:col-span-6 lg:col-start-7 text-lg leading-[1.6] text-ink/70">
                {it.d}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
